export const style = {
  CardWelcome: {
    color: "rgb(33, 43, 54)",
    transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    backgroundImage: "none",
    overflow: "hidden",
    borderRadius: "16px",
    position: "relative",
    zIndex: "0",
    boxShadow: "none",
    textAlign: "center",
    backgroundColor: "rgb(200, 250, 205)",
    padding: "24px",
    border: "none",
  },
  CardWelcomeLogo: {
    color: "rgb(33, 43, 54)",
    transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    backgroundImage: "none",
    overflow: "hidden",
    borderRadius: "16px",
    position: "relative",
    zIndex: "0",
    boxShadow: "none",
    textAlign: "center",
    backgroundColor: "rgb(255, 255, 255)",
    padding: "24px",
    border: "none",
  },
  CardWelcomeMedia: {
    height: "100%",
    display: "flex",
    textAlign: "left",
    alignItems: "center",
    justifyContent: "space-between",
  },
  Card: {
    backgroundColor: "rgb(255, 255, 255)",
    color: "rgb(33, 43, 54)",
    transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    backgroundImage: "none",
    overflow: "hidden",
    boxShadow:
      "rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px",
    borderRadius: "16px",
    // position: "relative",
    zIndex: "0",
    // display: "flex",
    // alignItems: "center",
    padding: "2%",
    border: "none",
  },
  Accordion: {
    borderRadius: "16px",
    border: "none",
  },
  CardStep: {
    color: "rgb(33, 43, 54)",
    transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    backgroundImage: "none",
    overflow: "hidden",
    borderRadius: "16px",
    position: "relative",
    boxShadow: "none",
    backgroundColor: "rgb(255, 255, 255)",
    border: "1px solid #CFD8DC",
    // padding: "24px",
    width: "100%",
  },
  CardContentSBU: {
    minHeight: "160px",
  },
};
